<template>
  <LoadingRights>
    <div class="fixed overflow-y-auto h-full w-full bg-white">
      <slot ></slot>
    </div>
  </LoadingRights>
</template>
